const VECTOR_KEYS = ['position', 'target', 'modelPosition', 'modelRotation']
const NUMBER_KEYS = ['explode', 'transparency', 'hideModel']

export function clamp01(value) {
  return Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0))
}

export function mix(a, b, progress) {
  return a + (b - a) * clamp01(progress)
}

export function interpolateSceneState(chapters, index, progress) {
  if (!Array.isArray(chapters) || chapters.length === 0) {
    throw new Error('At least one scene chapter is required')
  }

  const fromIndex = Math.min(Math.max(0, index), chapters.length - 1)
  const toIndex = Math.min(fromIndex + 1, chapters.length - 1)
  const from = chapters[fromIndex]
  const to = chapters[toIndex]
  const amount = clamp01(progress)
  const result = { ...from }

  VECTOR_KEYS.forEach((key) => {
    const fromValue = from[key] ?? [0, 0, 0]
    const toValue = to[key] ?? fromValue
    result[key] = fromValue.map((value, component) =>
      mix(value, toValue[component] ?? value, amount),
    )
  })

  NUMBER_KEYS.forEach((key) => {
    result[key] = mix(from[key] ?? 0, to[key] ?? from[key] ?? 0, amount)
  })

  result.focus = amount < 0.5 ? from.focus : to.focus
  result.accent = amount < 0.5 ? from.accent : to.accent
  return result
}

export function getExplodeOffset(name, amount) {
  const normalized = clamp01(amount)
  const offsets = {
    'high-pressure-boiler': [0, -0.54, 0],
    'pressure-relief-valve': [-0.48, -0.3, 0.36],
    'water-cooling-boiler': [0, -0.24, 0],
    'coil-heat-exchanger': [0.34, -0.08, 0.18],
    'pressure-column': [-0.25, -0.03, 0.28],
    'spring-housing': [0.3, 0.08, -0.18],
    'spring-loaded-valve': [-0.28, 0.16, -0.16],
    'fin-heat-exchanger': [0, 0.3, 0],
    'lower-grip-collar': [0.4, 0.3, 0],
    'lower-wood-grip': [0.7, 0.34, 0],
    'ground-coffee-basket': [0, 0.52, 0],
    'espresso-reservoir': [0, 0.78, 0],
    'upper-grip-collar': [0.2, 0.78, -0.32],
    'upper-wood-grip': [0.32, 0.82, -0.58],
  }
  const offset = offsets[name] ?? [0, 0, 0]
  return offset.map((value) => value * normalized)
}
